import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getCSRFToken, CSRF_HEADER_NAME } from './csrf';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: '',
    credentials: 'include', // Важно для cookies
    prepareHeaders: (headers) => {
      // Добавляем CSRF токен ко всем запросам; сервер проверяет его только
      // у мутирующих методов, лишний заголовок на GET безвреден.
      const csrfToken = getCSRFToken();
      
      if (csrfToken) {
        headers.set(CSRF_HEADER_NAME, csrfToken);
      }
      
      return headers;
    },
  }),
  tagTypes: ['Session', 'Me', 'Ratecards', 'Tags', 'TagsComment', 'TableColumns', 'Estimates', 'EstimateList', 'PickContext'],
  endpoints: () => ({}),
});
